import { Navigate, Route, Routes } from 'react-router-dom'

import Layout from './components/Layout'
import RequireAuth from './components/RequireAuth'
import Arcade, { ArcadeGame } from './pages/Arcade'
import Browse from './pages/Browse'
import Dashboard from './pages/Dashboard'
import Games from './pages/Games'
import LanguageDetail from './pages/LanguageDetail'
import LearnPath from './pages/LearnPath'
import Lesson from './pages/Lesson'
import Login from './pages/Login'
import PixelPaint from './pages/PixelPaint'
import Practice from './pages/Practice'
import Register from './pages/Register'
import SingAlong from './pages/SingAlong'
import MatchGame from './pages/games/MatchGame'
import RushGame from './pages/games/RushGame'

/** Everything behind a login, so the route table stays readable. */
function Private({ children }: { children: React.ReactNode }) {
  return <RequireAuth>{children}</RequireAuth>
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route
          index
          element={
            <Private>
              <Dashboard />
            </Private>
          }
        />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="browse" element={<Browse />} />

        {/* Readable by anyone for a published language; the page itself hides
            the editing controls when the viewer is not the owner. */}
        <Route path="languages/:id" element={<LanguageDetail />} />

        {/* Learning a language is owner-only, because progress must reference
            words you own -- learning someone else's gives you a copy first. */}
        <Route
          path="languages/:id/learn"
          element={
            <Private>
              <LearnPath />
            </Private>
          }
        />
        <Route
          path="languages/:id/lesson/:unit"
          element={
            <Private>
              <Lesson />
            </Private>
          }
        />
        <Route
          path="languages/:id/practice"
          element={
            <Private>
              <Practice />
            </Private>
          }
        />
        <Route
          path="languages/:id/games"
          element={
            <Private>
              <Games />
            </Private>
          }
        />
        <Route
          path="languages/:id/games/match"
          element={
            <Private>
              <MatchGame />
            </Private>
          }
        />
        <Route
          path="languages/:id/games/speed"
          element={
            <Private>
              <RushGame mode="speed" />
            </Private>
          }
        />
        <Route
          path="languages/:id/games/survival"
          element={
            <Private>
              <RushGame mode="survival" />
            </Private>
          }
        />
        <Route
          path="languages/:id/sing"
          element={
            <Private>
              <SingAlong />
            </Private>
          }
        />

        {/* The arcade. Nothing here touches a language. */}
        <Route
          path="arcade"
          element={
            <Private>
              <Arcade />
            </Private>
          }
        />
        <Route
          path="arcade/pixel-paint"
          element={
            <Private>
              <PixelPaint />
            </Private>
          }
        />
        <Route
          path="arcade/:game"
          element={
            <Private>
              <ArcadeGame />
            </Private>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
